import React, { ChangeEvent } from "react";
const favoriteFilterIcon = require("../../styles/favourite.svg");
import ActiveIcon from "../vectors/ActiveIcon";

interface FilterByFavoriteProps {
  updateFilter: Function;
  expanded: boolean;
  collapseFilter: Function;
  isActive: boolean;
  pageConfig: {
    accentColor: string;
  };
  trackFilterEvents: (filterType: string) => void;
}

class FilterByFavorite extends React.Component<FilterByFavoriteProps> {
  constructor(props: FilterByFavoriteProps) {
    super(props);
    this.handleSelectFavoritesFilter =
      this.handleSelectFavoritesFilter.bind(this);
  }

  handleSelectFavoritesFilter = (event: ChangeEvent<HTMLInputElement>) => {
    this.props.updateFilter(event.target.checked);
    if (event.target.checked) {
      this.props.trackFilterEvents("favorites");
    }
  };

  render() {
    return (
      <div className="panel panel-default">
        <div className="panel-heading" role="tab" id="favorite-section">
          {this.props.isActive && (
            <div className="active-icon">
              <ActiveIcon color={this.props.pageConfig.accentColor} />
            </div>
          )}
          <img src={favoriteFilterIcon} alt="" className="filter-icon" />
          <h4 className="panel-title">
            <a
              aria-expanded={this.props.expanded}
              className={`${this.props.expanded ? "" : "collapsed"}  ${
                this.props.isActive ? "active" : "inactive"
              }`}
              onClick={e => this.props.collapseFilter(e, "favorite")}
              role="button"
              data-toggle="collapse"
              data-parent="#filter-accordion"
              href="#collapse-favorite-section"
              aria-controls="collapse-favorite-section"
            >
              Favorites
            </a>
          </h4>
        </div>
        <div
          id="collapse-favorite-section"
          className={
            "panel-collapse collapse " + (this.props.expanded ? "in" : "")
          }
          role="tabpanel"
          aria-labelledby="favorite-section"
        >
          <div className="panel-body">
            <ul className="check-radio checkmark">
              <li>
                <label>
                  <input
                    type="checkbox"
                    id="checkbox"
                    checked={this.props.isActive}
                    onChange={this.handleSelectFavoritesFilter}
                  />
                  <span className="r-dot" />
                  <span className="r-desc">Show only favorites</span>
                </label>
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

export default FilterByFavorite;
